import { FC } from 'react';
import { useFormik } from 'formik';
import { Link as BrowserLink } from 'react-router-dom';
import * as Yup from 'yup';
import { Alert, Box, Button, Grid, InputAdornment, Typography } from '@material-ui/core';
import i18n from 'i18next';
import { LoginContainer } from 'src/components/loginContainer';
import { useAppDispatch, useAppSelector } from 'src/hooks/useStore';
import { InputField } from '../../components/input-field';
import { Mail as MailIcon } from '../../icons/mail';
import VectorIcon from '../../icons/vectorIcon';
import { resetPassword, selectAuth } from './authSlice';

const ForgotPasswordPage: FC = () => {
  const dispatch = useAppDispatch();
  const { status, error } = useAppSelector(selectAuth);

  const formik = useFormik({
    initialValues: {
      email: '',
      submit: null
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email('Email non valide').max(255).required('Champ obligatoire')
    }),
    onSubmit: async (values, helpers) => {
      try {
        const result = await dispatch(resetPassword(values.email));
        if (resetPassword.fulfilled.match(result)) {
          helpers.setStatus({ success: true });
          helpers.setSubmitting(false);
        } else {
          helpers.setStatus({ success: false });
        }
      } catch (err) {
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: err.message });
        helpers.setSubmitting(false);
      }
    }
  });
  return (
    <LoginContainer>
      <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            mb: 3
          }}
        >
          <Typography color="textPrimary" variant="h3">
            Mot de passe oublié
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <InputField
              error={Boolean(formik.touched.email && formik.errors.email)}
              fullWidth
              helperText={formik.touched.email && formik.errors.email}
              placeholder="Entrez votre email"
              name="email"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type="email"
              value={formik.values.email}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MailIcon />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12} style={{ paddingTop: '3vh' }}>
            <Button
              color="primary"
              disabled={formik.isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              Envoyer un e-mail de réception
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              color="primary"
              component={BrowserLink}
              to="/login"
              variant="text"
              startIcon={<VectorIcon />}
            >
              Se connecter
            </Button>
          </Grid>
        </Grid>
        {status === 'success' && (
          <Alert severity="success" sx={{ mt: 3 }}>
            {i18n.t('auth.success.emailSent')}
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mt: 3 }}>
            {i18n.t(`auth.errors.${error}`)}
          </Alert>
        )}
      </form>
    </LoginContainer>
  );
};
export default ForgotPasswordPage;
